<template>
    <v-dialog
        v-model="showDialog"
        max-width="600px"
        :fullscreen="this.$vuetify.breakpoint.xsOnly"
        scrollable
        persistent
    >
        <v-card id="reopen-dialog">
            <v-card-title class="text-h5 lighten-2">
                <v-icon
                    class="material-icons-outlined"
                    color="primary"
                >
                    lock_open
                </v-icon>
                <span>Re-Open Ticket</span>
                <!-- {{ headerText }}                -->
            </v-card-title>
            <v-divider />
            <v-card-text
                :class="[
                    $vuetify.breakpoint.xs ? 'custom-mobile-text-area' : '',
                    $vuetify.breakpoint.xs && submitted
                        ? 'd-flex justify-center align-center'
                        : '',
                ]"
            >
                Please select the tickets you want to re-open.
                <div v-if="!isLoading && !submitted">
                    <v-data-table
                        v-model="selected"
                        fixed-header
                        :headers="headers"
                        :items="selectedTickets"
                        item-key="TR_rowid"
                        :items-per-page="5"
                        :hide-default-footer="true"
                        show-select
                        :disable-pagination="true"
                        :disable-sort="true"
                        :disable-filter="true"
                        :single-select="false"
                        :mobile-breakpoint="0"
                        :class="[$vuetify.breakpoint.xs ? 'custom-mobile-table' : '']"
                        @toggle-select-all="selectAllToggle"
                    >
                        <template
                            v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
                        >
                            <v-simple-checkbox
                                :value="isSelected"
                                :readonly="item.TR_stage !== 'CT'"
                                :disabled="item.TR_stage !== 'CT' ? true : false"
                                @input="select($event)"
                            />                           
                        </template>                        
                        <template v-slot:[`item.ticket`]="{ item }">
                            {{ item.ticket }}-{{ item.revision }}
                        </template>
                        <template v-slot:[`item.TR_member_code`]="{ item }">
                            {{ item.TR_member_code }}
                        </template>
                        <template v-slot:[`item.TR_response_code`]="{ item }">
                            <v-tooltip
                                color="#34383f"
                                top
                                max-width="400"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <div
                                        v-bind="attrs"
                                        class="text-truncate"
                                        style="max-width:80px"
                                        v-on="on"
                                    >
                                        {{ item.TR_response_code || 'Un-Assigned' }}
                                    </div>
                                </template>
                                <span> {{ item.TR_response_code || 'Un-Assigned' }}</span>
                            </v-tooltip>                           
                        </template>
                        <template v-slot:[`item.TR_stage`]="{ item }">
                            <v-chip
                                x-small
                                :color="statusChipColor(item.TR_stage)"
                                outlined
                                :class="statusChipClass(item.TR_stage, item.TS_cancelled)"
                            >
                                {{ statusTextEx(item.TR_stage, item.TS_cancelled) }}
                            </v-chip>
                        </template>
                    </v-data-table>
                </div>
                <div
                    v-if="isLoading && submitted"
                    class="text-center"
                    style="margin: 32px 0px"
                >
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    />

                    <div class="control-title">
                        Please wait while we re-open your ticket
                    </div>
                </div>
                <div
                    v-if="!isLoading && submitted"
                    class="text-center"
                    style="margin: 32px 0px"
                >
                    <v-icon color="green">
                        check_circle
                    </v-icon>
                    <div class="control-title">
                        Completed Successfully
                    </div>
                    <v-list-item
                        three-line
                        style="background-color: var(--ll-surface-subtle)"
                        class="custom-list-item d-flex justify-space-between align-center"
                        :style="{ width: $vuetify.breakpoint.xs ? '90vw' : '' }"
                    >
                        <v-list-item-content
                            class="d-flex justify-space-between align-center"
                        >
                            <div style="max-width: 20%">
                                <PdfIcon />
                            </div>
                            <div
                                style="max-width: 80%"
                                class="text-start"
                            >
                                <b>{{ printTicketsResponse.task_output_ref }}</b>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn
                    style="text-transform: none !important"
                    outlined
                    light
                    :width="$vuetify.breakpoint.xs ? '50%' : ''"
                    @click="closeDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    v-if="!isLoading && !submitted"
                    style="text-transform: none !important"
                    :disabled="checkedCount"
                    depressed
                    color="primary"
                    :width="$vuetify.breakpoint.xs ? '50%' : ''"
                    @click="reopenTicket"
                >
                    Re-Open
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import {
    statusTextEx   
} from '../services/ticketDataHelpers';
import webtmsBackend from '@/services/webtmsBackend';
export default {
    props: {
        selectedTickets: {
            type: Array,
            default: () => ([]),
            required: true,
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            reopenDialog: false,
            isLoading: false,
            submitted: false,
            headers: [
                {
                    text: '',
                    value: '',
                },
                {
                    text: 'Ticket',
                    value: 'ticket',
                },
                {
                    text: 'Member Code',
                    value: 'TR_member_code',
                },

                {
                    text: 'Response Code',
                    value: 'TR_response_code',
                },
                {
                    text: 'Stage',
                    value: 'TR_stage',
                },
            ],
            selected: [],
            disabledCount: 0,
        };
    },
    computed: {
        reopenDisabled() {
            return this.selected.length === 0;
        },
        checkedCount() {
            return this.selected.length === 0;
        },
        showDialog: {
            get() {
                return this.show;                
            },
            set() {
                this.$emit('close-reopen-dialog');
            },
        },
        headerText() {
            if(this.selectedTickets.length > 0 && this.selectedTickets.length === 1) {
                return `Re-Open ${ this.selectedTickets.length } Ticket`;
            } else if(this.selectedTickets.length > 0 && this.selectedTickets.length > 1) {
                return `Re-Open ${ this.selectedTickets.length } Tickets`;
            }else {
                return `Re-Open Ticket`;
            }
        },
    },
    created() {
        this.selected = [];
    },
    methods: {                         
        async reopenTicket() {
            // this.$emit('reopen', this.selectedTickets);
            let payload = [];
            this.selected.map((item) => {
                if (item.TR_stage === 'CT'){
                    payload.push(item.TR_rowid);
                }               
            });           
            let postReopenTicketResult = await webtmsBackend.reOpenTicket(payload);
            // raise event for parent to indicate success
            this.$emit('reopen-success', postReopenTicketResult);
            this.reopenDialog = false;
        },
        closeDialog() {
            this.showDialog = false;
            this.selected = [];
        },
        selectAllToggle(props) {
            if (this.selected.length != this.selectedTickets.length - this.disabledCount) {
                this.selected = [];
                props.items.forEach((item) => {
                    if (item.TR_stage === 'CT') {
                        this.selected.push(item);
                    }
                });               
            } else this.selected = [];
        },
        statusChipColor(stage) {
            return stage === 'CT' ? '#FFB300' : 'green';
        },
        statusChipClass(stage,cancelled) {
            return `status-${statusTextEx(stage,cancelled).toLowerCase()}-chip`;
        },
        statusTextEx(stage,cancelled) {
            return statusTextEx(stage,cancelled);
        },
    },
};
</script>
<style>
#reopen-dialog .response-info-box {
  text-align: center;
  height: 40px;
  font-size: 14px;
  background-color: var(--ll-surface-subtle);
  line-height: 40px;
  font-weight: 500;
  color: var(--ll-text-primary);
}
#reopen-dialog .member-table-label {
  font-size: 14px;
  color: var(--ll-text-primary);
  font-weight: 500;
}
#reopen-dialog .v-data-table {
  border: 1px solid var(--ll-border);
  width: 100%;
  overflow: hidden;
}
#reopen-dialog.v-data-table__wrapper {
  border-radius: 4px;
}
#reopen-dialog thead,
#reopen-dialog th {
  background-color: var(--ll-surface-subtle);
}
</style>
